import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const PersonIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => {
  return (
    <svg data-testid={testID} width={size} height={size} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5284 3.11234C13.5284 4.27895 12.5826 5.22467 11.416 5.22467C10.2494 5.22467 9.30369 4.27895 9.30369 3.11234C9.30369 1.94572 10.2494 1 11.416 1C12.5826 1 13.5284 1.94572 13.5284 3.11234ZM12.8601 6.48428C14.0616 8.08437 15.4889 9.44451 17.2284 10.4515C18.4501 11.1596 17.6012 13.2179 16.3629 12.4991C15.1212 11.7796 14.0034 10.942 12.9954 9.97638C12.9827 11.2931 13.0257 12.6082 13.1442 13.9274C13.1583 14.0843 13.2591 14.5656 13.3008 14.6885C14.0168 16.8298 14.7343 18.9703 15.4527 21.1119C15.9316 22.5399 13.7163 23.2814 13.2388 21.8538C12.5821 19.8973 11.926 17.9399 11.2703 15.9834L11.268 15.9764C11.215 15.9788 11.1626 15.9788 11.1103 15.9767C10.082 17.9665 9.42278 19.8458 8.74047 22.1667C8.60071 22.6425 8.18278 22.9609 7.71529 22.9967C7.57965 23.007 7.4392 22.9933 7.30012 22.9523C6.68597 22.7716 6.3338 22.1268 6.51488 21.5123C7.25433 18.9951 7.98277 16.9375 9.12156 14.7629C9.26546 14.4878 9.33603 14.1849 9.32639 13.875C9.29747 12.9445 9.23998 10.8742 9.25754 9.7268C8.79968 10.269 8.38624 10.8136 8.02167 11.3565C7.80892 11.6746 7.45916 11.8464 7.10321 11.8464C6.89149 11.8464 6.6784 11.7858 6.4894 11.6591C5.98266 11.3197 5.84772 10.6336 6.18715 10.1265C7.01749 8.88854 8.06436 7.6513 9.29816 6.45089C10.1092 5.47803 12.1052 5.4226 12.8601 6.48428Z"
        fill={color}
      />
    </svg>
  );
};

export { PersonIcon };
